import React from "react";
import { ReactNode } from "react";
import { WithRouterProps } from "react-router";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { getCollection, getProduct } from "../../apis/api";
import { CollectionInfo, ProductInfo } from "../../models/system";
//@ts-ignore
@withRouter
export class SavingDetial extends React.Component<Partial<RouteComponentProps<{ id: string }>>>{

    private number: string[] = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"]
    state = { data: null as CollectionInfo | null }
    componentDidMount(): void {
        getCollection(this.props.match!.params.id).then((data) => {
            this.setState({ data });
        });
    }
    render(): ReactNode {

        return (
            <section className="bg savingdetial">
                <div className="pic">
                    <img src={this.state.data?.pic}></img>
                </div>
                <div className="content">
                    <div className="name">【<span> {this.state.data?.title}</span>】</div>
                    <div className="time"><label>年代</label><span>{this.state.data?.time}</span></div>
                    <div><label>规格</label><span>{this.state.data?.specifications}</span></div>
                    <div className="text"><label>简介</label><div dangerouslySetInnerHTML={{
                        __html: this.state.data?.content ?? ""
                    }}></div></div>

                    <div className="product_styles">
                        {
                            this.state.data?.photo?.split(";").map((item, idx) => {
                                return <div><img src={item}></img></div>
                            })
                        }
                    </div>
                </div>
            </section >
        )
    }
}
